import { useCallback, useMemo } from "react";

// Cache global: cada som é pré-carregado uma vez
const cache = {};

function getAudio(src) {
  if (!cache[src]) {
    const audio = new Audio(src);
    audio.preload = "auto";
    cache[src] = audio;
  }
  return cache[src];
}

/**
 * Hook para tocar efeitos sonoros.
 * 
 * const { play } = useSoundEffect();
 * play(successSound, { volume: 0.8 });
 * play(popSound,     { volume: 0.6, delay: 100 });
 */
const useSoundEffect = () => {
  const play = useCallback((src, { volume = 1, delay = 0 } = {}) => {
    if (!src) return;
    try {
      // cloneNode permite sobreposição (tocar o mesmo som duas vezes)
      const base  = getAudio(src);
      const clone = base.cloneNode();
      clone.volume = Math.min(1, Math.max(0, volume));

      const fire = () => clone.play().catch(() => {
        // silencia erros de autoplay policy do browser/mobile
      });

      delay > 0 ? setTimeout(fire, delay) : fire();
    } catch {
      // não quebra se Web Audio não estiver disponível
    }
  }, []);

  /* ESTÁVEL, e não um objeto novo a cada render. Quem consome põe o retorno
     na lista de dependências de um efeito; com identidade nova a cada render,
     o efeito roda sempre. Foi o que fez o som de aula concluída tocar em
     sequência em vez de uma vez. */
  return useMemo(() => ({ play }), [play]);
};

export default useSoundEffect;